import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/technology-competitors-architecture.svg")